import Vue from 'vue'
import VueRouter from 'vue-router'

import User from './user'
import PerfilUsuario from './perfil_usuario'
import Groups from './groups'
import Companies from './companies'
import Units from './units'
// import GrupoChecklist from './grupo_checklist' // Removido - agora gerenciado via ChecklistTemplates
// import ItemChecklist from './item_checklist' // Removido - agora gerenciado via ChecklistTemplates
import Checklists from './checklists'
import ChecklistTemplates from './checklist_templates'
import ChecklistExecutions from './checklist_executions'
import ChecklistSchedules from './checklist_schedules'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    User,
    PerfilUsuario,
    Groups,
    Companies,
    Units,
    // GrupoChecklist, // Removido - agora gerenciado via ChecklistTemplates
    // ItemChecklist, // Removido - agora gerenciado via ChecklistTemplates
    Checklists,
    ChecklistTemplates,
    ChecklistExecutions,
    ChecklistSchedules,

    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const perfil_id = localStorage.getItem('perfil_id');
  const authenticated = localStorage.getItem('token');
  let to_splited = to.path.toString().split('/')
  to_splited = to_splited.filter(part => part !== '')

  if (to.path === '/login' && to.query.user && to.query.token) {
    next();
    return true;
  }

  if (to.path === '/login' && authenticated) {
    next('/');
    return true;
  }

  if (
    !authenticated &&
    (
      !(['/login'].includes(to.path.toString())) &&
      !(['public'].includes(to_splited[0]))
    )
  ) {
    next('/login');
    return true;
  }

  if (authenticated && perfil_id == 20 && !(['profile', 'condutor', 'index', 'view', 'condutor/index', 'visualizar-solicitacao', 'condutor/checklist', 'checklist',].includes(to_splited[0]))) {
    next('/condutor/index');
    return true;
  }

  if (authenticated && perfil_id == '2') {
    const allowedPaths = [
      '/', '/home',
      '/checklists',
      '/checklists/view',
      '/checklist-executions',
    ];

    const isAllowed = allowedPaths.some(path => {
      return to.path === path || to.path.startsWith(path + '/') || to.path.startsWith(path + '?');
    });

    if (!isAllowed) {
      next('/checklists');
      return true;
    }
  }

  if (to.meta.perfil_id) {
    if (!to.meta.perfil_id.includes(perfil_id)) {
      if (perfil_id == '2') {
        next('/checklists');
      } else {
        next('/');
      }
      return true;
    }
  }

  next();
});

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router